module.exports = __webpack_public_path__ + "static/media/den-logo.64648b1c.png";